module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-breakpoints/gatsby-browser.js'),
      options: {"plugins":[],"queries":{"sm":"(min-width: 576px)","md":"(min-width: 768px)","l":"(min-width: 992px)","xl":"(min-width: 1200px)","portrait":"(orientation: portrait)"}},
    },{
      plugin: require('../plugins/gatsby-plugin-deferred-gtm/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-MBMM2MH","includeInDevelopment":false,"defaultDataLayer":{"platform":"gatsby"},"routeChangeEventName":"WEBSITE-ROUTE-CHANGE"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
